export const breakpoints = {
    maxTablet: '767px',
    tablet: '768px'
};

export const MODAL_STYLE_RESET = {
    overlay: {
        position: null,
        top: null,
        left: null,
        right: null,
        bottom: null,
        backgroundColor: null,
    },
    content: {
        position: null,
        top: null,
        left: null,
        right: null,
        bottom: null,
        border: null,
        background: null,
        overflow: null,
        WebkitOverflowScrolling: null,
        borderRadius: null,
        outline: null,
        padding: null,
    },
};

/*
w600
w1200
s520
s400
 */

export const IMAGE_SIZES = {
    AVATAR: '/s400/',
    BANNER: '/w600/'
};
